













































import { defineComponent, reactive, toRefs, onMounted, watch } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { SearchCondition, Room } from "../../modules/teacher/RoomList"

export interface Data {
  tabNo: number
  condition: SearchCondition
  rooms: Room[]
  fields: any[]
  errors: string[]
  isAllCheckedDelete: boolean
  delete_ids: number[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 1,
      condition: new SearchCondition(),
      rooms: new Array<Room>(),
      fields: [
        {key: "room_code", label: "教室CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "教室名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center'},
      ],
      errors: [],
      isAllCheckedDelete: false,
      delete_ids: [],
    });

    /************************************************************
     * 削除処理
     ************************************************************/

    const deleteRoom = async (): Promise<void> => {

      if (!state.delete_ids.length) {
        alert(`削除する教室をチェックしてください。`);
        return;
      }

      if (!confirm(`本当に削除してよろしいでしょうか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/room_list/delete_room`, {ids: state.delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    }

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/room_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.rooms = response.data.rooms.map((x: any) => new Room(x)); 
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {

      context.root.$store.dispatch("showOverlay", "ダウンロード中... しばらくお待ちください。");

      await http.get(`/api/room_list/download?${Common.BuildQuery(state.condition, 'search_condition')}`, {responseType: 'arraybuffer'}).then(async response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `教室マスタ.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {

      state.delete_ids = [];

      if (newVal) {
        state.delete_ids = state.rooms.map(x => x.id);
      }
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
    });

    return {
      ...toRefs(state),
      search,
      clearCondition,
      deleteRoom,
      download,
    };
  }
});
